import { BentoRow, BentoRowProps } from '../../components/Bento/Bento'
import { createWidget } from '../widget-utils'

export const BentoRowWidget = ({
  isLoading,
  ...props
}: BentoRowProps & { isLoading?: boolean }) => <BentoRow {...props} />

export const BentoRowWidgetDefinition = createWidget(BentoRowWidget, {
  type: 'BentoRow',
})
